// const io = require('socket.io-client');
import { Video, room, hideSideMenu, socket, localRecording, permissions, isElectron } from '../libs/roomnew';
import moment from 'moment';
import kinoTooltip from '../room/kinoTooltip'
import LoadingCircle from '../components/LoadingCircle';
import sanitizeHtml from 'sanitize-html';
import KinoStreamService from '../features/stream/KinoStreamService';

export default class LiveStream {

    constructor() {

        this.streamingData = []

        this.config = {
            pauseTime: 5 * 60 * 1000,              // Milliseconds
        }

        this.streamingList = []
        this.disabled=false;
        this.streamingServices = [
            {
                name            : 'youtube',
                oauth_url       : '/services/stream/youtube',
                // card 244
                title           : "YouTube",
                // end card 244
                description     : '',
                auth_url        : 'auth_url',
                logo_image      : `<i class="fab fa-youtube"></i>`,
                classIcon       : `youtube-icon`,
                available       : true,
                color           : '#FF0000'
            },
            // card 663
            {
                name            : 'facebook',
                oauth_url       : '/services/stream/facebook',
                title           : "Facebook",
                description     : "",
                auth_url        : "",
                logo_image      : `<i class="fab fa-facebook-square"></i>`,
                classIcon       : `facebook-icon`,
                available       : true,
                color           : '#4267B2'
            },
            // end card 663
            // {
            //     name            : 'twitch',
            //     oauth_url       : '/services/stream/twitch',
            //     title           : "Twitch",
            //     description     : "",
            //     auth_url        : "",
            //     logo_image      : `<i class="fab fa-twitch"></i>`,
            //     classIcon       : `twitch-icon`,
            //     available       : false,
            //     color           : '#6441a5'
            // },
            // {
            //     name            : 'twitter',
            //     oauth_url       : '/services/stream/twitter',
            //     title           : "Twitter",
            //     description     : "",
            //     auth_url        : "",
            //     logo_image      : '<i class="fab fa-twitter"></i>',
            //     classIcon       : `twitter-icon`,
            //     available       : false,
            //     color           : '#1DA1F2'
            // }

            // {
            //     name            : 'linkedin',
            //     oauth_url       : '/services/stream/linkedin',
            //     title           : "LinkedIn",
            //     description     : "",
            //     auth_url        : "",
            //     logo_image      : '<i class="fab fa-linkedin"></i>',
            //     classIcon       : `linkedin-icon`,
            //     available       : false,
            //     color           : '#0a66c2'
            // }

            //add the linked in as well
        ]

        this.servers = [
            'kino-stream1.kinetxco.com',
        ];
        this.currentServer = 0;

        this.connectedServices = []
        this.streamingStatus = "stopped"

        this.activeStreamingServices = [];
        this.streamStartedAt            = null
        this.streamTimeCounter          = null;
        this.showStreamingBarTooltip    = false

        this.btnLabel                   = 'Live Stream'
        this.addNewChanngelBtn          = $('#add-new-channel-btn')
        this.editStreamTitlesBtn        = $('#edit-stream-titles-btn')
        this.previewStreamBtn           = $('#preview-stream-btn')
        this.addVideoSourceBtn          = $('#add-video-source-btn')
        this.saveStreamTitleBtn         = $('#save-title-btn')
        this.goLiveBtn                  = $('#go-live-btn');
        this.stopStreamingBtn           = $('#stop-streaming-btn')
        //this.pauseStreamingBtn          = $('#pause-streaming-btn')

        //back buttons
        this.fromPreviewStream          = $('#preview-stream-modal-back-btn')
        this.fromAddChannel             = $('#channel-list-selection-modal-back-btn')
        this.fromSingleService          = $('#single-service-auth-modal-back-btn')

        this.toggleAllOnBtn             = $('#toggle-all-on-btn')
        this.toggleAllOffBtn            = $('#toggle-all-off-btn')

        // modals
        this.channelSelectionModal      = $('#channel-list-selection-modal')
        this.singleServiceAuthModal     = $('#single-service-auth-modal')
        this.servicesModal              = $('#live-stream-modal')
        this.previewStreamModal         = $('#preview-stream-modal')
        this.liveStreamModal            = $('#live-modal-modal')
        this.streamTitleModal           = $('#stream-title-modal')
        this.pendingStreamModal         = $('#pending-stream-modal')
        this.resumeModal                = $('#resume-preview-stream-modal')
        this.facebookSelectionModal     = $('#facebook-service-selection-modal')


        // lists
        this.channelListGroup           = $('#channel-list-group')

        // buttons

        this.RTMPServerAddressField     = $('#rtmp_server_address')
        this.RTMPServerKeyField         = $('#rtmp_server_key')
        this.connectServiceBtn          = $('#connect-service')
        this.cancelRestreamBtn          = $('#cancel-restream-btn')
        this.openResumeModalBtn         = $('#resume-stream-modal-btn')
        this.minimizeFirstModal         = $('#live-stream-modal-first');
        this.channelListMinimize        = $('#live-stream-modal-channel-list');
        this.facebookModalMinimize      = $('#live-stream-modal-facebook');
        this.authModalMinimize          = $('#live-stream-modal-auth');
        this.singleModalMinimize        = $('#live-stream-modal-single');
        this.previewModalMinimize       = $('#live-stream-modal-preview');
        this.titleModalMinimize         = $('#live-stream-modal-title-minimize');
        this.pendingModalMinimize       = $('#live-stream-modal-pending');

        //icons
        this.checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 191.667 191.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
        <path xmlns="http://www.w3.org/2000/svg" d="M95.833,0C42.991,0,0,42.99,0,95.833s42.991,95.834,95.833,95.834s95.833-42.991,95.833-95.834S148.676,0,95.833,0z   M150.862,79.646l-60.207,60.207c-2.56,2.56-5.963,3.969-9.583,3.969c-3.62,0-7.023-1.409-9.583-3.969l-30.685-30.685  c-2.56-2.56-3.97-5.963-3.97-9.583c0-3.621,1.41-7.024,3.97-9.584c2.559-2.56,5.962-3.97,9.583-3.97c3.62,0,7.024,1.41,9.583,3.971  l21.101,21.1l50.623-50.623c2.56-2.56,5.963-3.969,9.583-3.969c3.62,0,7.023,1.409,9.583,3.969  C156.146,65.765,156.146,74.362,150.862,79.646z" fill="#022735" data-original="#000000" style="" class=""/>
        </g></svg>`;
        this.liveStreamIcon             = '<i class="fas fa-satellite-dish"></i>'

        this.mustHaveModerator = 'You must have moderator rights to stream this Kino';

        this.streamService=new KinoStreamService('stream');
        this.streamService.getServers();
        this.events()
        this.onLoad()
    }

    addOptionButton() {
        var rec = this;
        // if (rec.btn !== null || !room.isModerator()) {
        //     return
        // }
        let optionIcon = $('<div/>', {
            class: "option-icon",
            id:"liveStreamIcon",
            html: `<i class="fas fa-satellite-dish"></i>`,
        });
        let optionName = $('<div/>', {
            class: "option-name",
            html: "Live Streaming",
        });
        let optionAction = $('<div/>', {
            class: "option-action",
            html: '',
        });
        let optionDescription = $('<div/>', {
            class: "option-description",
            html: [ optionName, optionAction],
        });
        this.liveStreamModalBtn = $('<div/>', {
            class: `option ${!permissions.hasLiveStreaming() || !rec.streamingPermissions ? 'feature-disabled' : ''}`,
            id: 'live-stream-modal-btn',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': '',
            html: [optionIcon, optionDescription],
        }).on('click',()=>{
            if(!permissions.hasLiveStreaming()){
                return;
            }
            //this.startNewTimer();
            // rec.renderModal();
            if(permissions.hasLiveStreaming() && rec.streamingPermissions){
                hideSideMenu();
                if(isElectron){
                    let os= api.global.sendSync('os');
                    if(os=="darwin"){
                        $("#alertModal").modal('show');
                        $("#alertModalBody").html('Please use Google Chrome to use the Live Streaming on Mac OS');
                        // console.log('O System == darwin: '+ os);
                        return;
                    }
                }
                // if(res.isAvailable){
                //     res.renderRecordingNotAvailable();
                //     return;
                // }
                rec.showLiveStream();
            }
            // rec.noPermissionsToRecord();
        }).on('mouseenter',()=>{
            if(!permissions.hasLiveStreaming()){
                if(permissions.isWorkspace){

                    if(this.liveStreamModalBtn.attr('data-original-title') == `This feature is disabled in this workspace.`)return
                    this.liveStreamModalBtn.attr('data-original-title', `This feature is disabled in this workspace.`)
                    return
                }else{
                    if(this.liveStreamModalBtn.attr('data-original-title') == "")return
                    this.liveStreamModalBtn.attr('data-original-title', rec.mustHaveModerator)
                    return
                }
            }else if(!rec.streamingPermissions){
                this.liveStreamModalBtn.attr('data-original-title',`Live Streaming add-on not available.`)
            }else if(!rec.disabled){
                this.liveStreamModalBtn.attr('data-original-title', '')
            }
        });

        $("#option-list").find("#live-stream-modal-btn").remove();
        $("#option-list").append(this.liveStreamModalBtn);
    };

    events() {
        // this.liveStreamModalBtn.on('click', e => this.showLiveStream(e))
        this.addNewChanngelBtn.on('click', e => this.showAddNewChannel(e))
        this.editStreamTitlesBtn.on('click', e => this.showEditTitles(e))
        this.connectServiceBtn.on('click', e => this.openAuthenticateWindow(e))
        $('#channel-list-group').on('click', `button[data-service]`, e => this.openAuthenticateWindow(e))
        this.addVideoSourceBtn.on('click', e => this.addVideoSource(e));
        this.previewStreamBtn.on('click', e => this.openPreviewModal(e))
        this.saveStreamTitleBtn.on('click', e => this.saveStreamTitle(e))
        this.goLiveBtn.on('click', e => this.startStreaming())
        $('#channel-list-selection-modal').on('hidden.bs.modal', e => $('#streaming-connection-error-list').html('') )
        $('#stream_title').on('input change paste', e => {
            if($('#stream_title').val().length) {
                $('#stream_title-error').html('')
            } else {
                $('#stream_title-error').html('Stream title is required.')
            }

        })
        //back buttons
        this.fromPreviewStream.on('click', e => this.backFromPreviewStream(e))
        this.fromAddChannel.on('click', e => this.backFromAddChannel(e))
        this.fromSingleService.on('click', e => this.backFromSingleService(e))
        this.stopStreamingBtn.on('click', e => {
            this.video_stream.stop()
        })
        //this.pauseStreamingBtn.on('click', e => this.pauseStreaming(e))

        $('#stream-channel-list').on('change', 'input', e => this.setStreamingStatus(e))
        $('#stream-channel-list').on('click', '[data-action="remove"]', e => this.removeStreamingService(e))

        this.cancelRestreamBtn.on('click', e => this.cancelResumeStream());
        this.openResumeModalBtn.on('click', e => this.openResumeStreamModal())

        this.minimizeFirstModal.on('click', e => {
            Video.minimizedContent.minimizeModal('live-stream-modal', this.liveStreamIcon);
        })
        this.channelListMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('channel-list-selection-modal', this.liveStreamIcon);
        })
        this.facebookModalMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('facebook-service-selection-modal', this.liveStreamIcon);
        })
        // this.authModalMinimize.on('click', e => {
        //     Video.minimizedContent.minimizeModal('auth-service-modal', this.liveStreamIcon);
        // })
        this.singleModalMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('single-service-auth-modal', this.liveStreamIcon);
        })
        this.previewModalMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('preview-stream-modal', this.liveStreamIcon);
        })
        this.titleModalMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('stream-title-modal', this.liveStreamIcon);
        })
        this.pendingModalMinimize.on('click', e => {
            Video.minimizedContent.minimizeModal('pending-stream-modal', this.liveStreamIcon);
        })

        // card 244
        // $('#pending-stream-modal button.close-button-modal-kino').on('click', e => )
        // $('#preview-stream-modal button.close-button-modal-kino').on('click', e => this.closeStreamModal())
        // end card 244

        // this.channelSelectionModal.on('show.bs.modal', e => this.checkModalShow(e))
        // this.singleServiceAuthModal.on('show.bs.modal', e => this.checkModalShow(e))
        // this.servicesModal.on('show.bs.modal', e => this.checkModalShow(e))
        // this.previewStreamModal.on('show.bs.modal', e => this.checkModalShow(e))
        // this.liveStreamModal.on('show.bs.modal', e => this.checkModalShow(e))
        // this.streamTitleModal.on('show.bs.modal', e => this.checkModalShow(e))

        // card 244
        //on modal open events
        $('#preview-stream-modal-back-btn').on('click', e => {
            if(this.video_stream) this.video_stream.stop()
            $('#tool-box .kino-tooltip-container').remove()
        })
        $('#pending-stream-modal button.close-button-modal-kino').on('click', e => {
            if(this.video_stream) this.video_stream.stop()
            $('#tool-box .kino-tooltip-container').remove()
            this.closeStreamModal()
            this.cancelResumeStream()
        })
        // end card 244

        $(document).on('mouseover mousemove', '#streaming-menu .social-container', e => this.showStreamingList(e));
        $(document).on('mouseover mousemove', '#streaming-indicator', e => this.showUserStreamingList(e));

        // card 663
        $('#facebook-list-selection').on('change', e => this.facebookAccountSelection_Changed())
        $('#facebook-service-selected-btn').on('click', e => this.selectFacebookAccount())
        $('#facebook-back-to-platforms').on('click', e => {
            $('#channel-list-selection-modal').modal('show');
            $('#facebook-service-selection-modal').modal('hide');
        })
        // end card 663
    }

    unload() {

        if(this.streamingStatus == "streaming") {
            Video.showNotification('<i class="fas fa-stop-circle"></i>', `You stopped streaming this Kino`)
            socket.sendBroadcastMessage({
                eventName: "stoppedStreaming",
                data: {
                    sender: {
                        id: room.myUserId(),
                        name: MY_NAME
                    }
                },
                room_id:room.getName()
            });
        }
    }

    mixer(stream1, stream2) {
        const ctx = new AudioContext({sampleRate: 48000})
        const dest = ctx.createMediaStreamDestination();

        if (stream1.getAudioTracks().length > 0){
            ctx.createMediaStreamSource(stream1).connect(dest);
        }

        if (stream2.getAudioTracks().length > 0){
            ctx.createMediaStreamSource(stream2).connect(dest);
        }

        let tracks = dest.stream.getTracks();
        tracks = tracks.concat(stream1.getVideoTracks()).concat(stream2.getVideoTracks());

        return new MediaStream(tracks)

    }

    removeStreamingService(e) {
        let service = $(e.currentTarget).data('name')

        axios.post(`/services/stream/${service}`, {_method: 'DELETE'}).then(res => {
            this.connectedServices = this.connectedServices.filter(srv => service != srv.name)
            this.activeStreamingServices = this.activeStreamingServices.filter(element => element != service)

            if(!this.connectedServices.length) {
                $('#stream-channel-list .errors').html('')
                $('#stream-channel-list .errors').append(this.showErrorMessage("You must connect at least 1 streaming service to start streaming."));
            }
            this.refreshLoadedServicesHTML()
        }).catch(err => {
        })

    }

    stoppedStreamingEvent(data) {
        try {
            Video.showNotification('<i class="fas fa-stop-circle"></i>', `${data.data.sender.name} stopped streaming this Kino`)
            $(`#${data.data.sender.id} .streaming-indicator`).removeClass('streaming-on')
            this.streamingList = this.streamingList.filter(pp => pp != data.data.sender.id)
            this.liveStreamCountsEvent()
        } catch (error) {
        }
    }

    async onLoad() {

        await axios.get('/services/stream/check/permission').then(res => {
            if(res.data.status == false) {
                this.streamingPermissions = false
                return
            }
            this.streamingPermissions = true
        }).catch(err => {
            this.streamingPermissions = false
        })

        this.loadCurrentChannels()

        let streaming_stats = localStorage.getItem('streaming_status');
        if(streaming_stats) {
            streaming_stats = JSON.parse(streaming_stats)
            this.cancelResumeStream()
            localStorage.removeItem('streaming_status');
            if(permissions.hasLiveStreaming() && streaming_stats['status'] && streaming_stats['kino_id'] == ROOM_NAME ) {
                this.singleServiceAuthModal.modal('hide')
                this.previewStreamModal.modal('hide')
                this.channelSelectionModal.modal('hide')
                this.streamTitleModal.modal('hide')
                this.servicesModal.modal('hide')
                this.resumeModal.modal('hide')
                this.liveStreamModal.modal('hide')

                // checking if we are streaming in the same room_id
                // if(streaming_stats['lastUpdate'] && moment().diff(moment(streaming_stats['lastUpdate'])) > 1000 ) {
                //     if(streaming_stats['last_pause_update']) {

                //         if(moment().diff(moment(streaming_stats['last_pause_update'])) > 1000) {
                //             this.pendingStreamModal.modal()
                //             this.pausedTimer = setInterval(e => {
                //                 let streaming_stats = localStorage.getItem("streaming_status")
                //                 if(streaming_stats) {
                //                     streaming_stats = JSON.parse(streaming_stats);
                //                     streaming_stats['last_pause_update'] = moment()
                //                     localStorage.setItem('streaming_status', JSON.stringify(streaming_stats));
                //                 }


                //             }, 300);
                //         }
                //     } else {
                //         this.pendingStreamModal.modal()
                //     }
                // }
            }
        } else {

        }
    }

    loadCurrentChannels() {
        axios.get('/services/stream').then(res => {
            $('#stream-channel-list .errors').html('')
            if(res.data.length) {
                this.connectedServices = res.data
                this.activeStreamingServices = res.data.map(element => {
                    // console.log('live_lement', element)
                    return element.name
                })



            } else {
                $('#stream-channel-list .errors').append(this.showErrorMessage('You must have connected at least one account to start streaming.'))
            }
            this.refreshLoadedServicesHTML()
        }).catch(err => {
            this.connectedServices = []
        })
    }

    userJoined(data) {
        if(data.data && data.data.participant && data.data.participant != room.myUserId()) {
            if(this.streamingStatus == "streaming") {
                socket.sendBroadcastMessage({
                    eventName: "streamingServices",
                    data: {
                        sender: {
                            id: room.myUserId(),
                            name: MY_NAME
                        },
                        receiver: data.data.participant,
                        streaming_socials: this.activeStreamingServices
                    },
                    room_id:room.getName()
                });
            }
        }
    }

    loadStreamingServices(data) {
        if(data.data && data.data.sender && data.data.receiver && data.data.receiver == room.myUserId()) {
            Video.showNotification('', `${data.data.sender.name} is streaming this Kino to
                <div class="d-flex ml-2">
                    ${data.data.streaming_socials.map(social => {
                        return `
                        <div class="ml-1" style="color: ${this.streamingServices.find(streaming_service => streaming_service.name == social).color}">
                            ${this.streamingServices.find(streaming_service => streaming_service.name == social).logo_image}
                        </div>
                        `
                    }).join('')}
                </div>
            `)
            $(`#${data.data.sender.id} .streaming-indicator`).addClass('streaming-on')
            this.streamingList.push(data.data.sender.id)
            this.liveStreamCountsEvent()
        }
    }

    showAddNewChannel(e) {
        this.servicesModal.modal('hide')
        this.channelSelectionModal.modal()
        this.channelListGroup.html('')
        this.channelListGroup.append(
            this.streamingServices.map( streaming_service => {
                return `
                    <div class="box-streaming-item ${(!streaming_service.available || this.connectedServices.find(el => streaming_service.name == el.name)) ? `disabled` : ``}">
                        <button data-service="${streaming_service.name}" class="btn"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Connect with ${streaming_service.name}">
                            <div class="card box-card">
                                <div class="card-body">
                                    <div>
                                        <div class="logo service-logo service-${streaming_service.name}">
                                            ${streaming_service.logo_image}
                                        </div>
                                        <div class="title service-title service-${streaming_service.name}">
                                            ${streaming_service.title}
                                        </div>
                                    </div>
                                </div>
                                ${(streaming_service.available) ? `
                                    ${this.connectedServices.find(el => streaming_service.name == el.name) ? `
                                        <div class="stream-service-checked">
                                            ${this.checkIcon}
                                        </div>
                                    ` : ``}
                                ` : `
                                    <div class="streaming-service-coming-soon">
                                        <div>
                                            <span>Coming Soon</span>
                                        </div>
                                    </div>
                                `}
                            </div>
                        </button>
                    </div>
                `
            } ).join('')
        )
    }

    openAuthenticateWindow(e) {
        $('#streaming-connection-error-list').html('')
        let service_name = $(e.currentTarget).data('service')
        this.selectedService = this.streamingServices.find(service => service.name == service_name)
        if(!this.selectedService || !this.selectedService.available) return false
        let authWindow = window.open(this.selectedService.oauth_url, this.selectedService.title, 'width=800, height=600');
        window.liveStream = this

    }

    // card 663
    facebookAccountSelection_Changed() {
        let selected_value = $('#facebook-list-selection').val()
        $('#facebook-list-selection').addClass('option-selected')
        if(selected_value == "user_account") {
            $('#facebook-list-selection').parent().removeClass('d-none')
            $('#facebook-list-selection-pages').parent().addClass('d-none')
            $('#facebook-list-selection-groups').parent().addClass('d-none')
        } else if(selected_value == "user_page") {
            $('#facebook-list-selection-pages').parent().removeClass('d-none')
            $('#facebook-list-selection-groups').parent().addClass('d-none')
        } else if(selected_value == "user_group") {
            $('#facebook-list-selection-groups').parent().removeClass('d-none')
            $('#facebook-list-selection-pages').parent().addClass('d-none')
        }
    }

    selectFacebookAccount() {
        let selected_value = $('#facebook-list-selection').val()
        $('#facebook-list-selection').addClass('option-selected')
        this.selected_account_type = "account"
        let selected_account_id = "me"
        if(selected_value == "user_account") {
            this.selected_account_type = 'account'
            selected_account_id = 'me'
        } else if(selected_value == "user_page") {
            this.selected_account_type = 'page'
            selected_account_id = $('#facebook-list-selection-pages').val()
        } else if(selected_value == "user_group") {
            this.selected_account_type = 'group'
            selected_account_id = $('#facebook-list-selection-groups').val()
        }

        let nextBtn = new LoadingCircle();
        nextBtn.buttonShow($('#facebook-service-selected-btn'))
        axios.post(`/services/stream/facebook/platform`, {
            id: selected_account_id,
            type: this.selected_account_type
        }).then(res => {
            this.connectedServices.push({
                name: 'facebook',
                title: res.data.title,
                account_name: res.data.account_name,
            })
            this.refreshLoadedServicesHTML()
            $('#facebook-service-selection-modal').modal('hide')
            $('#facebook-profile-picture').removeClass('skeleton');
            $('#facebook-user-name').html('');
            $('#channel-list-selection-modal').modal('hide')
            $('#live-stream-modal').modal()
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            nextBtn.buttonHide($('#facebook-service-selected-btn'))
        })
    }


    authenticationWindowFailed(message) {
        $('#facebook-service-selection-modal').modal('hide')
        this.channelSelectionModal.modal();
        $('#streaming-connection-error-list').html('')
        $('#streaming-connection-error-list').append(this.showErrorMessage(message));
    }


    authenticationWindowClosed(_platform = "youtube") {
        let ls=this;
        if(_platform && _platform == "facebook") {
            $('#facebook-profile-picture').addClass('skeleton');
            $('#facebook-user-name').html('');
            var uID, accessToken;
            axios.get('/services/stream/facebook/platform').then(res => {
                this.channelSelectionModal.modal('hide');
                $('#facebook-list-selection-groups').empty()
                $('#facebook-list-selection-pages').empty()
                $('#facebook-list-selection-groups').empty()
                res.data.pages.forEach(streaming_service => {
                    $('#facebook-list-selection-pages').append(`
                        <option value="${streaming_service.id}">${streaming_service.name}</option>
                    `)
                })
                res.data.groups.forEach(streaming_service => {
                    $('#facebook-list-selection-groups').append(`
                        <option value="${streaming_service.id}">${streaming_service.name}</option>
                    `)
                })

                FB.getLoginStatus(function(response) {
                    console.log("Facebook login status",response)
                    // if(!response.authResponse){
                    //     $('#stream-channel-list .errors').html(ls.showErrorMessage("Facebook authentication failed. Response: "+response.status));
                    //     ls.servicesModal.modal('show');
                    //     FB.logout();
                    //     return
                    // }
                        if(response.authResponse){
                        uID = response.authResponse.userID;
                        accessToken = response.authResponse.accessToken;
                        }
                        FB.api('/me', { access_token: accessToken }, function(response) {
                            // console.log(response);
                            $('#facebook-profile-picture').attr("src", `http://graph.facebook.com/${response.id}/picture?type=large`);
                            $('#facebook-user-name').html(response.name);
                        });
                        ls.liveStreamModal.hide()
                        $('#facebook-service-selection-modal').modal()
                });
                // console.log(FB.getAuthResponse());

            }).catch(err => {
                console.error(err)
            })
        } else {
            axios.get('/services/stream').then(res => {
                $('.stream-channel-list .channels').html('')
                res.data.filter(service_element => {
                    return !this.connectedServices.find(service => service.name == service_element.name)
                }).forEach(service_element => {
                    let service = this.streamingServices.find(streaming_service => streaming_service.name == service_element.name);
                    service['backupIngestionAddress']       = service_element.backupIngestionAddress
                    service['ingestionAddress']             = service_element.ingestionAddress
                    service['rtmpsBackupIngestionAddress']  = service_element.rtmpsBackupIngestionAddress
                    service['rtmpsIngestionAddress']        = service_element.rtmpsIngestionAddress
                    service['streamName']                   = service_element.streamName
                    service['account_name']                 = service_element.account_name
                    this.connectedServices.push(service);
                })
                // console.log(this.connectedServices)
                this.refreshLoadedServicesHTML()
                this.singleServiceAuthModal.modal('hide')
                // this.streamTitleModal.modal();
                this.channelSelectionModal.modal('hide')
                $('#stream-channel-list .errors').html('')
                this.servicesModal.modal();
            }).catch(err => {
                console.error(err)
            })
        }
    }

    authenticationWindowCanceled() {
        $('#streaming-connection-error-list').html('')
        $('#streaming-connection-error-list').append(this.showErrorMessage("Kino requires YouTube permissions to allow live streaming."));
    }
    // card 663

    showVideo(stream) {
        this.stream = stream;
        let videoStream=this.stream.getTracks().find(t=>t.kind=="video");
        if(videoStream && videoStream.label.startsWith('screen')){
            let tooltip = new kinoTooltip("tool-box","Click hide to remove streaming overlay.", {left: '59%', bottom: '160%'});
            tooltip.addTooltip();
            setTimeout(() => {
                tooltip.hideTooltip()
        }, 5000);
        }


        try {
            let preview = document.querySelector('#streaming-preview-container video')
            if ('srcObject' in preview) {
                preview.srcObject = stream;
            } else {
                // Avoid using this in new browsers, as it is going away.
                preview.src = URL.createObjectURL(stream);
            }
        } catch (error) {
        }
    }

    showStreamingList(e) {

        if(this.streamingList.length) {
            clearTimeout(this.showRecordingListTimeout)

            let name_list = '<span><b>Streaming by:</b></span>'
            name_list += '<span>'
            name_list += this.streamingList.map(item => {
                if(!room.getParticipantById(item))  return MY_NAME
                return room.getParticipantById(item)._displayName
            }).join('</span></span>')
            name_list+= '</span>'
            $('#streaming-list').html(name_list);

            $('#streaming-list').addClass('d-flex')

            this.showRecordingListTimeout = setTimeout(() => {
                $('#streaming-list').removeClass('d-flex')
            }, 4000);
        }
    }

    showUserStreamingList(e) {

        if(this.streamingList.length) {
            clearTimeout(this.showUserStreamingListTimeout)

            let name_list = '<span><b>Streaming by:</b></span>'
            name_list += '<span>'
            name_list += this.streamingList.map(item => {
                if(!room.getParticipantById(item))  return MY_NAME
                return room.getParticipantById(item)._displayName
            }).join('</span></span>')
            name_list+= '</span>'
            $('#who-streaming-list').html(name_list);
            $('#who-streaming-list').addClass('d-flex')

            this.showUserStreamingListTimeout = setTimeout(() => {
                $('#who-streaming-list').removeClass('d-flex')
            }, 4000);
        }

    }

    showTheStreamerName(){
        const streamerNames = this.streamingList.map((item) => {
            const displayName = room.getParticipantById(item)._displayName;
            return displayName
        });

        if(streamerNames.length <= 1){
            $('#whoStreaming').html(`${streamerNames[0]} is streaming`);
        }else {
            $('#whoStreaming').html(`${streamerNames.length} Participants live streaming`);
        }
    }

    liveStreamCountsEvent() {
        // Users are streaming
        if(!this.streamingList.length) {
            $('#streaming-indicator').removeClass('d-flex')
            $('.streaming-indicator2-container').removeClass('d-flex')
            return
        }

        // User is in Live Stream
        if($('#streaming-menu.visible').length) {
            $('#streaming-indicator').removeClass('d-flex')
            $('.streaming-indicator2-container').removeClass('d-flex')
            return
        }

        $('#streaming-indicator').addClass('d-flex')
        $('.streaming-indicator2-container').addClass('d-flex')

        this.showTheStreamerName()
    }

    async addVideoSource(e) {
        $('#preview-stream-modal .stream-preview-container .errors').html('')

        let displayMediaStreamConstraints = {
            video: {
                displaySurface: "browser",
                selfBrowserSurface: "include",
                frameRate: {
                    ideal: 24,
                    max: 30,
                },
                height: {
                    ideal: 1080,
                    max: 1200
                },
                width:{
                    ideal:1920,
                    max:1920
                }
            },
            preferCurrentTab: true,
            surfaceSwitching: "exclude",
            audio: {
                noiseSuppression: false,
                echoCancellation: false
            }
        };


        if(!this.stream || !this.stream.active) {
            this.video_stream = await navigator.mediaDevices.getDisplayMedia(displayMediaStreamConstraints).then(stream => stream).catch(err => err);
            console.log("Captured video stream",this.video_stream)
            this.video_stream.oninactive = e => {
                if(this.streamingStatus == "initiating") {
                    this.streamingStatus = "stopped";
                    this.stopStreaming(false)
                } else if(this.streamingStatus == "streaming" || this.streamingStatus == "paused") {
                    this.streamingStatus = "stopped";
                    this.stopStreaming(true)
                } else {
                    this.stopStreaming(false)
                }

                this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
            }

            this.video_stream.onstop = e => {
                if(this.streamingStatus == "initiating") {
                    this.streamingStatus = "stopped";
                    this.stopStreaming(false)
                }
                else if(this.streamingStatus == "streaming" || this.streamingStatus == "paused") {
                    this.streamingStatus = "stopped";
                    this.stopStreaming(true)
                } else {
                    this.stopStreaming(false)
                }

                this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)

            }

            if(this.video_stream.active) {
                if(this.video_stream.getAudioTracks().length) {
                    this.stream = this.video_stream
                    this.showVideo(this.video_stream)
                    $('#add-video-source-btn').addClass('d-none')
                    $('#streaming-source').removeClass('d-none')
                    this.goLiveBtn.removeClass('disabled')
                } else {
                    let vid=this.video_stream.getTracks().find(t=>t.kind=="video");
                    let isWindow=false;
                    if(vid && vid.label.startsWith('window')){
                        isWindow=true;
                    }
                    console.log("User choosen video window",isWindow);
                    this.video_stream.stop();

                    $('#add-video-source-btn').removeClass('d-none')
                    $('#streaming-source').addClass('d-none')

                    // User didnt provide microphone
                    $('#preview-stream-modal .stream-preview-container .errors').html('')
                    $('#preview-stream-modal .stream-preview-container .errors').html(this.showErrorMessage(`${ isWindow ? 'Unable to get audio from selected Window source. Please choose a different streaming source and check <strong>Share Audio</strong>' : 'Please check <strong>Share Audio</strong> when selecting the streaming source.' }`))
                }
            }else {
                return false;
            }
            return false;
        }

    }

    openPreviewModal(e) {
        if(!this.activeStreamingServices.length) {
            $('#stream-channel-list .errors').html('')
            $('#preview-stream-modal .stream-preview-container .errors').html('');
            if(!this.connectedServices.length) {
                $('#stream-channel-list .errors').append(this.showErrorMessage("You must connect at least 1 streaming service to start streaming."));
            } else {
                $('#stream-channel-list .errors').append(this.showErrorMessage("You must select at least one streaming service to start streaming."));
            }
            return;
        }
        $('#go-live-btn').text("Go Live")
        $('#preview-stream-modal .stream-preview-container .errors').html('');
        this.previewStreamModal.modal()
        this.servicesModal.modal('hide')
    }

    refreshLoadedServicesHTML() {
        let element = $('.stream-channel-list .channels')
        element.html('')

        let streaming_services_html = this.connectedServices.map(service => {
            // card 244
            return `
                <div class="channel">
                    <div class="information">
                        <div class="image ${this.streamingServices.find(srv => srv.name == service.name).classIcon}"></div>
                        <div class="name">
                            <span class="service-name">${service.title}</span>
                            <div class="account-name">
                                <span class="bracket">(</span>
                                <span class="user-name">${service.account_name.length > 20 ? service.account_name.substring(0, 20) + '...' : service.account_name }</span>
                                <span class="bracket">)</span>
                            </div>
                        </div>
                    </div>
                    <div class="channel-status d-flex justify-content-between">
                        <div>
                            <button data-action="remove" data-name="${service.name}" type="button" class="btn btn-sm add-button-split-convo d-flex" style="color: #880000 !important">
                                Remove
                            </button>
                        </div>
                        <div class="stream-status">
                            <label class="switch">
                                <input type="checkbox" data-name="${service.name}" id="force-auto-participants-checkbox"${(this.activeStreamingServices.find(activeService => activeService == service.name)) ? ' checked' : ''}>
                                <span class="slider-checkbox round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            `}).join('')
            // end // card 244
        if(streaming_services_html.length) {
            element.append(streaming_services_html);
        } else {
            element.append($('<div />', {
                id: 'add-channel-streaming-placeholder',
                html: 'Click ✚ to add a service'
            }).on('click', e => {
                this.showAddNewChannel(e)
            }) );
        }

    }

    setStreamingStatus(e) {
        if($(e.currentTarget).is(':checked')) {
            this.activeStreamingServices.push($(e.currentTarget).data('name'))
        } else {
            this.activeStreamingServices = this.activeStreamingServices.filter(service => {
                return service != $(e.currentTarget).data('name')
            })
        }
        if(this.activeStreamingServices.length) {
            this.hideErrorMessage()
        }
    }

    saveStreamTitle(e) {
        axios.post('/services/stream', {
            stream_title: $('#stream_title').val(),
            stream_description: $('#stream_description').val()
        }).then(res => {
        }).catch(err => {
        });
    }

    // card 244
    requestAccessAgain(service_name) {

        $('#streaming-connection-error-list').html('')
        this.selectedService = this.streamingServices.find(service => service.name == service_name)
        if(!this.selectedService) return false
        let authWindow = window.open(this.selectedService.oauth_url + "?retry=true", this.selectedService.title, 'width=800, height=600');
        window.liveStream = this

    }

    requestAccessAgainWindowClosed() {
        axios.get('/services/stream').then(res => {
            let service = this.streamingServices.filter(service => {
                return service.name == "youtube"
            })[0];
            res.data.forEach(service => {
                this.activeStreamingServices.push(service.name)
            })
            service['backupIngestionAddress']       = res.data[0].backupIngestionAddress
            service['ingestionAddress']             = res.data[0].ingestionAddress
            service['rtmpsBackupIngestionAddress']  = res.data[0].rtmpsBackupIngestionAddress
            service['rtmpsIngestionAddress']        = res.data[0].rtmpsIngestionAddress
            service['streamName']                   = res.data[0].streamName
            service['account_name']                 = res.data[0].account_name
            this.connectedServices.push(service);
            $('#preview-stream-modal .stream-preview-container .errors').empty()

            this.refreshLoadedServicesHTML()
            // $('#preview-stream-modal .stream-preview-container .errors').append(this.showSuccessMessage('Access regained'))
        }).catch(err => {
        })
    }

    requestAccessAgainWindowCanceled() {
        $('#preview-stream-modal .stream-preview-container .errors').html('')
        $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage(`
            Kino requires YouTube permissions to allow streaming.
        `))
    }

    checkYourGoogleAccountAgain() {
        $('#preview-stream-modal .stream-preview-container .errors').html('')
        $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage(`Your account is not authorized to stream on YouTube. Please go to <a target="_blank" href="https://youtube.com/">youtube.com</a> and make sure Live Streaming is enabled on your account.`))
    }

    // end card 244

    createMediaRecorder(){
        // let options = {
        //     audioBitsPerSecond : 128000
        // }
        let options;
        if(MediaRecorder.isTypeSupported('video/webm;codecs=h264')){
            options = {mimeType: 'video/webm;codecs=h264',audioBitsPerSecond : 128000};
        }else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
            options = {mimeType: 'video/webm;codecs=vp9',audioBitsPerSecond : 128000};
        } else {
            options = {mimeType: 'video/webm; codecs=vp8,opus',audioBitsPerSecond : 128000};
        }
        this.mediaRecorder = new MediaRecorder(this.recorderStream, options);
        this.mediaRecorder.start(200);
        this.mediaRecorder.onstop = (e) => {
            this.enableRecorder();
            // this.video_stream.stop()
            // if(this.streamingStatus == "streaming") {
            //     this.streamingStatus = "stopped"
            //     this.stopStreaming(true)
            // } else {
            //     this.stopStreaming(false)
            // }
        }

        this.mediaRecorder.onpause = (e) => {
        }

        this.mediaRecorder.ondataavailable = (e) => {
            if(this.streamingStatus == "streaming") {
                try {
                    // this.socket.emit("binarystream",e.data);
                    this.streamService.sendData(e.data);
                    let streaming_stats = localStorage.getItem('streaming_status')
                    if(streaming_stats) {
                        streaming_stats = JSON.parse(streaming_stats)
                        streaming_stats['lastUpdate'] = moment()
                    } else {
                        streaming_stats = {
                            title: "",
                            description: stream_description,
                            status: 1,
                            startTime: moment(),
                            lastUpdate: moment()
                        }
                    }
                    streaming_stats = JSON.stringify(streaming_stats)
                    localStorage.setItem('streaming_status', streaming_stats)
                } catch (error) {
                }
            }
        }
    };

    async startStreaming(...params){
        if(params) {
            params = params[0]
            if(params && params.currentServer) {
                this.currentServer = params.currentServer
            }
        }
        let status = "new"
        this.streamingStatus = "initiating"
        this.disableRecorder();
        // if(this.streamingStatus == "streaming") {
        //     this.channelSelectionModal.modal('hide')
        //     this.singleServiceAuthModal.modal('hide')
        //     this.servicesModal.modal('hide')
        //     this.previewStreamModal.modal('hide')
        //     this.liveStreamModal.modal('hide')
        //     this.streamTitleModal.modal('hide')
        //     this.pendingStreamModal.modal('hide')
        //     this.resumeModal.modal('hide')

        //     $('#modal-error-message').text('You have an active stream on another window.')
        //     $('#error-modal').modal()

        //     return
        // }

        $('#streaming-menu .streaming-label-container .streaming-label').text('Live Streaming')
        clearInterval(this.pausedTimer)


        // card 244
        let stream_title            = sanitizeHtml($('#stream_title').val(), {
                allowedTags: [],
                allowedAttributes: {
                    span: [],
                    img: []
                },
                allowedSchemesByTag: {
                    img: []
                }
            })
        let stream_description      = sanitizeHtml($('#stream_description').val(), {
                allowedTags: [],
                allowedAttributes: {
                    span: [],
                    img: []
                },
                allowedSchemesByTag: {
                    img: []
                }
            })
        if(!this.servers[this.currentServer]) {
            $('#preview-stream-modal .stream-preview-container .errors').html('')
            this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
            $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Streaming is unavailable at this time. Please try again later.'))
            this.currentServer = 0;
            this.enableRecorder();
            return false;
        }
        let socket_address          = this.servers[this.currentServer]
        // end card 244
        let streamingServices       = []
        let stream_destinations     = []

        // let socketOptions = {
        //     transports: ['websocket'],
        //     upgrade: false,
        //     secure: true,
        //     reconnection: true,
        //     reconnectionAttempts: 3,
        //     randomizationFactor: 0.3,
        //     reconnectionDelay: 500,
        //     timeout: 10000,
        //     query: {
        //         framespersecond: 30,
        //         audioBitrate: 44100
        //     }
        // };

        if(this.streamingStatus == "stopped") return false


        // Making sure user is sharing the screen
        if(!this.stream) {
            this.addVideoSource(new Event(''))
            this.enableRecorder();
            return false
        }


        if(!this.stream.active) {
            this.addVideoSource(new Event(''))
            this.enableRecorder();
            return false
        }


        //checking if user is sharing the audio
        if(!this.stream.getAudioTracks().length) {
            this.stream.stop()
            this.addVideoSource(new Event(''))
            this.enableRecorder();
            return false
        }


        if(!stream_title.length) {
            $('#stream_title').focus()
            $('#stream_title-error').text('Stream title is required.')
            this.enableRecorder();
            return false
        } else {
            $('#stream_title-error').html('')
        }

        if(stream_title.length > 100) {
            $('#stream_title').focus()
            $('#stream_title-error').text('Stream title cannot be longer than 100 characters.')
            this.enableRecorder();
            return false
        } else {
            $('#stream_title-error').html('')
        }

        if(this.streamingStatus == "stopped") {
            this.enableRecorder();
            return false;
        }


        this.goLiveLoadingBtn = new LoadingCircle();
        this.goLiveLoadingBtn.buttonShow(this.goLiveBtn)

        if(this.streamingStatus == "stopped") {
            this.enableRecorder();
            return false;
        }


        //check if we have available space for streaming in the server
        // let server_status = await axios.get(`https://${this.servers[this.currentServer]}/status`).then(res => res).catch(err => err);

        // if(this.streamingStatus == "stopped") return false


        // if(!server_status.data) {
        //     $('#preview-stream-modal .stream-preview-container .errors').html('')
        //     this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
        //     // card 244
        //     $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Access to your YouTube account has been removed. Please allow access to your YouTube account.'))
        //     // end card 244
        //     return false;
        // }

        // if(this.streamingStatus == "stopped") return false


        // if(server_status.data.percentage.idle < 20) {
        //     if(this.servers[++this.currentServer]) {
        //         this.startStreaming({currentServer: this.currentServer++})
        //     }
        //     this.currentServer = 0
        //     $('#preview-stream-modal .stream-preview-container .errors').html('')
        //     this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
        //     $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Streaming is unavailable at this time. Please try again later.'))

        //     return false;
        // }

        let preparation = await axios.post('/services/stream/prepare', {
            title: stream_title,
            description: stream_description,
            streaming_services: this.activeStreamingServices,        // card 663
            kino_id:ROOM_NAME,
            reset_service:true
        }).then(res => res).catch(err => {
            console.log("error response", err.response.data);
            if(err.response.data && err.response.data.message){
                $('#preview-stream-modal .stream-preview-container .errors').html(this.showErrorMessage(err.response.data.message))
                this.goLiveLoadingBtn.buttonHide(this.goLiveBtn);
                this.streamingStatus = "stopped";
                return false;
            }
        })

        if(this.streamingStatus == "stopped") {
            this.enableRecorder();
            return false;
        }


        if(preparation?.status == 200) {
            streamingServices = preparation.data.map(stream => {
                return {
                    ingestion_address: stream.content.ingestion_address,
                    stream_name: stream.content.stream_name
                }
            })
            $('#preview-stream-modal .stream-preview-container .errors').html('')
        } else {

            // card 244
            if(preparation?.data.error.status == "UNAUTHENTICATED") {
                this.connectedServices = this.connectedServices.filter(service => service.name != "youtube");
                this.connectedServices = this.connectedServices.filter(service => service.name != "youtube");
                $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Access to your YouTube account has been removed. Please allow access to your YouTube account.'))
                this.refreshLoadedServicesHTML()
                this.requestAccessAgain('youtube')
                this.video_stream.stop()
                this.enableRecorder();
                return false;
            }
            // console.log('live_error', preparation.data)
            if(preparation?.data.error && preparation?.data.error.errors.length && preparation.data.error.errors[0]['reason'] == "liveStreamingNotEnabled" ) {
                $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage(`Your account is not authorized to stream on YouTube. Please go to <a target="_blank" href="https://youtube.com/">youtube.com</a> and make sure Live Streaming is enabled on your account.`))
                this.video_stream.stop()
                this.enableRecorder();
                return false;
            }
            // end card 244
            $('#preview-stream-modal .stream-preview-container .errors').html('')
            try {
                $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage(preparation.data.error.message))
            } catch (error) {
                $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Streaming service unavailable, please try again later.'))
            }
            this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
            this.enableRecorder();
            return false;
        }

        if(this.streamingStatus == "stopped"){
            this.enableRecorder();
            return false;
        }


        stream_destinations = streamingServices.map(stream =>{
            return `${stream.ingestion_address}/${stream.stream_name}`
        })


        if(!stream_destinations.length) {
            $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Streaming service unavailable, please try again later.'))
            this.goLiveLoadingBtn.buttonHide(this.goLiveBtn);
            this.enableRecorder();
            return
        }

        // this.streamService.socketStartStream({type:'stream',rtmp:stream_destinations});
        //connect to socket
        try {
            if(this.streamService.socket && this.streamService.socket.connected){
                console.log("Found a conenction still open closing it");
                this.streamService.closeSocket();
            }
            console.log("Waiting for connection..",this.streamService.socket);
            let connected=await this.streamService.socketStartStream({type:'stream',rtmp:stream_destinations});
            console.log("Was connection ok",connected);
            if(connected===false){
                this.video_stream.stop()
                // this.gdmStream.getTracks().forEach(track => track.stop());
                // this.serviceUnavailableModal();
                this.enableRecorder();
                return;
            }
        } catch (error) {
            // this.gdmStream.getTracks().forEach(track => track.stop());
            console.error(error);
            // this.serviceUnavailableModal();
            this.enableRecorder();
            return;
        }

        // this.socket = io.connect(socket_address, socketOptions);

        // if(this.streamingStatus == "stopped") return false


        // if(!socket.connected) {
        //     socket.close()
        //     $('#preview-stream-modal .stream-preview-container .errors').append(this.showErrorMessage('Streaming service unavailable, please try again later.'))
        //     this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
        //     return
        // }

        // this.socket.emit('config_rtmp_destinations',stream_destinations);
        // this.socket.emit('start','start');

        // setting localstorage items
        let streaming_stats = localStorage.getItem("streaming_status")
        if(streaming_stats) {
            status = "resumed"
            streaming_stats = JSON.parse(streaming_stats);
        } else {
            streaming_stats = {}
        }

        if(this.streamingStatus == "stopped") {
            this.enableRecorder();
            return false;
        }

        if(streaming_stats && streaming_stats['lastUpdate'] && streaming_stats['kino_id'] == ROOM_NAME) {
            let duration = moment.duration(moment(streaming_stats['lastUpdate']).diff(moment(streaming_stats['startTime'])));
            streaming_stats['startTime'] = moment().subtract(duration)
        } else {
            streaming_stats['startTime'] = moment()
        }
        streaming_stats['kino_id'] = ROOM_NAME
        streaming_stats['title'] = stream_title
        streaming_stats['description'] = stream_description
        streaming_stats['status'] = "streaming"
        if(streaming_stats['last_pause_update']) {
            delete streaming_stats['last_pause_update']
        }

        // if(this.streamingStatus == "stopped") return false

        localStorage.setItem('streaming_status', JSON.stringify(streaming_stats));


        if(!this.mediaRecorder) {

            // var options;
            // if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
            //     options = {mimeType: 'video/webm;codecs=vp9'};
            // } else {
            //     options = {mimeType: 'video/webm; codecs=vp8,opus'};
            // }
            /*let user_audio = await navigator.mediaDevices.getUserMedia({
                video: false,
                audio: true
            });*/
            let user_audio;
            try {
                let localAudio=room.getLocalAudioTrack();
                if(localAudio){
                    console.log("got local audio");
                    user_audio=localAudio.stream;
                }
            } catch (error) {
                console.error('error getting local audio',error)
            }
            // var options;
            // if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
            //     options = {mimeType: 'video/webm;codecs=vp9'};
            // } else {
            //     options = {mimeType: 'video/webm; codecs=vp8,opus'};
            // }
            this.recorderStream = this.mixer(this.video_stream, user_audio)
            this.createMediaRecorder();

            // this.socketEvents(this.socket);
        }

        if(this.streamingStatus == "stopped") {
            this.enableRecorder();
            return false;
        }


        this.streamingStatus = "streaming"

        this.previewStreamModal.modal('hide')
        this.updateStreamingSocials()
        // if(this.streamingStatus == "stopped") return false
        setTimeout(() => {
            this.goLiveLoadingBtn.buttonHide(this.goLiveBtn)
        }, 1000);
        $('#streaming-menu').addClass('visible')
        this.startStreamTimeCounter(streaming_stats['startTime'])
        this.streamLogInterval = setInterval( () => {
            axios.post('/services/stream/log', {
                kino_id: ROOM_NAME
            }).then(res => {
            }).catch(err => {
            })
        }, 10000);

        // if(this.streamingStatus == "stopped") return false

        this.pauseStreamingBtnReady = true;
        //this.pauseStreamingBtn.attr('disabled', false)

        let stream_message = ""
        if(status == "new") {
            stream_message = "started_streaming"
            $('#streaming-menu .flicker').addClass('animated')
            try {
                Video.showNotification('<i class="fas fa-play-circle"></i>', `You started streaming this Kino`)
            } catch (error) {
            }

        }
        else {
            stream_message = "resumed_streaming"
            $('#streaming-menu .flicker').addClass('animated')
            try {
                Video.showNotification('<i class="fas fa-play-circle"></i>', `You resumed streaming this Kino`)
            } catch (error) {
            }
        }
        // if(this.streamingStatus == "stopped") return false
        this.broadcastMessage(stream_message)
        this.streamingList.push(room.myUserId())
        // if(this.streamingStatus == "stopped") return false
        this.liveStreamCountsEvent()
    }

    getParticipantDisplayName(pId) {
    }

    async pauseStreaming(e) {
        this.getParticipantDisplayName('ec6ff8a7')
        e.preventDefault()
        if(!this.pauseStreamingBtnReady) return
        this.pauseStreamingBtnReady = false;
        //this.pauseStreamingBtn.attr('disabled', true)
        if(this.streamingStatus == "streaming") {
            this.pausedStatus = true
            $('#streaming-menu .flicker').removeClass('animated')
            this.streamingStatus = "paused"
            $(e.currentTarget).find('i').attr('class', 'fas fa-play-circle')
            $(e.currentTarget).attr('title', 'Resume Streaming')
            $(e.currentTarget).attr('data-original-title', 'Resume Streaming')
            e.preventDefault()
            clearInterval(this.streamTimeCounter)

            let streaming_stats = localStorage.getItem("streaming_status")
            if(streaming_stats) {
                streaming_stats = JSON.parse(streaming_stats);
                streaming_stats['status'] = "paused"
                localStorage.setItem('streaming_status', JSON.stringify(streaming_stats));
            }
            try {
                this.streamService.closeSocket();
            } catch (error) {
            }

            try {
                this.mediaRecorder.stop()
                this.mediaRecorder = null;
            } catch (error) {
            }

            try {
                this.pausedTimer = setInterval(e => {
                    let streaming_stats = localStorage.getItem("streaming_status")
                    if(streaming_stats) {
                        streaming_stats = JSON.parse(streaming_stats);
                        streaming_stats['last_pause_update'] = moment()
                        localStorage.setItem('streaming_status', JSON.stringify(streaming_stats));
                    }
                    if(streaming_stats && streaming_stats['lastUpdate'] && moment().diff(moment(streaming_stats['lastUpdate'])) > this.config.pauseTime) {
                        // this.streamingStatus = "stopped"
                        if(this.video_stream) {
                            this.video_stream.stop();
                        }
                        clearInterval(this.pausedTimer);
                    }
                    if(!streaming_stats || !streaming_stats['lastUpdate']) {
                        clearInterval(this.pausedTimer)
                    }
                }, 300);
            } catch (error) {
                clearInterval(this.pausedTimer)
            }

            clearInterval(this.streamLogInterval)
            $('#streaming-menu .streaming-label-container .streaming-label').text('Paused')
            this.pauseStreamingBtnReady = true;
            //this.pauseStreamingBtn.attr('disabled', false)
            this.broadcastMessage("paused_streaming")
            try {
                Video.showNotification('<i class="fas fa-pause-circle"></i>', `You paused streaming this Kino`)
            } catch (error) {
            }
            this.streamingList = this.streamingList.filter(pp => pp != room.myUserId())
            this.liveStreamCountsEvent()
            return
        }
        clearInterval(this.pausedTimer)
        $(e.currentTarget).find('i').attr('class', 'fas fa-pause-circle')
        $(e.currentTarget).attr('title', 'Pause Streaming')
        $(e.currentTarget).attr('data-original-title', 'Pause Streaming')
        $('#streaming-menu .timer span.current_time').text('')
        await this.startStreaming()
        //this.pauseStreamingBtn.attr('disabled', false)

    }

    async resumePendingStream() {

    }

    openResumeStreamModal() {
        $('#pending-stream-modal').modal('hide')
        $('#preview-stream-modal').modal()
        this.pendingStreamStatus = true;
        let streaming_stats = localStorage.getItem('streaming_status')
        if(streaming_stats) {
            streaming_stats = JSON.parse(streaming_stats);
            $('#stream_title').val(streaming_stats['title'])
            $('#stream_description').val(streaming_stats['description'])
            $('#go-live-btn').text("Resume")
        }
    }

    async cancelResumeStream() {
        if(this.pausedTimer) {
            clearInterval(this.pausedTimer)
        }
        $('#pending-stream-modal').modal('hide')
        await axios.get('/services/stream/cancel-resume').then(res => {
        }).catch(err => {
        })
        localStorage.removeItem('streaming_status')
        this.pendingStreamStatus = false;

        this.streamingStatus = "stopped"
        if(this.video_stream) {
            this.video_stream.stop();
        }

    }

    async closeStreamModal() {
        if(this.pendingStreamStatus) {
            this.pendingStreamModal.modal()
        }

        this.video_stream.stop()
    }

    // card 244
    onNameChanged(user_id, display_name) {
        setTimeout(() => {
            let elem = $(`#${user_id} .video-top-toolbar .video-top-toolbar-right .streaming-indicator`)
            elem.attr('title', `${display_name} is streaming this Kino.`)
            elem.attr('data-original-title', `${display_name} is streaming this Kino.`)
        }, 500);
    }
    // end card 244

    // checkYourGoogleAccount(url) {
    checkYourGoogleAccount() {
        $('#streaming-connection-error-list').html('')
        $('#streaming-connection-error-list').append(this.showErrorMessage(`Your account is not authorized to stream on YouTube. Please go to <a target="_blank" href="https://youtube.com/">youtube.com</a> and make sure Live Streaming is enabled on your account.`))
    }

    startStreamTimeCounter(start_time) {
        $('#streaming-menu .timer span.current_time').text('')
        this.streamTimeCounter = setInterval(() => {
            let current_difference = [];
            let current_time = moment()
            let difference = moment.duration(current_time.diff(start_time));



            let hours_diff = difference.hours()
            let minutes_diff = difference.minutes()
            let seconds_diff = difference.seconds()

            current_difference.push((hours_diff > 9) ? `${hours_diff}` : `0${hours_diff}`)
            current_difference.push((minutes_diff > 9) ? `${minutes_diff}` : `0${minutes_diff}`)
            current_difference.push((seconds_diff > 9) ? `${seconds_diff}` : `0${seconds_diff}`)

            current_difference = current_difference.join(':')
            $('#streaming-menu .timer span.current_time').text(current_difference)
        }, 1000)

    }

    updateStreamingSocials() {
        $('#streaming-menu .streaming-socials').html('')
        $('#streaming-menu .streaming-socials').html(`
            <div class="d-flex justify-content-between flex-row">
            ${this.streamingServices.map((streaming_service, index) => {
                return `
                    <div class="soc-item d-flex justify-content-between">
                        <span class="${this.activeStreamingServices.find(active_service => streaming_service.name == active_service) ? 'active-social': ''}" >
                            <i class="fab fa-${streaming_service.name}"></i>
                        </span>
                    </div>
                `
            }).join('')}
            </div>
        `)
    }

    async stopStreaming(showMessage = true) {
        this.enableRecorder();
        //$('#pause-streaming-btn').find('i').attr('class', 'fas fa-pause-circle')
        //$('#pause-streaming-btn').attr('title', 'Pause Streaming')
        //$('#pause-streaming-btn').attr('data-original-title', 'Pause Streaming')
        $('#add-video-source-btn').removeClass('d-none')
        $('#streaming-source').addClass('d-none')
        this.goLiveBtn.addClass('disabled')

        clearInterval(this.streamTimeCounter)
        this.streamingStatus = "stopped"

        try {
            this.streamService.closeSocket();
            // this.socket.close()
            // this.socket.destroy()
            // this.socket = null
        } catch (error) {
        }

        try {
            this.mediaRecorder.stop()
            this.mediaRecorder.release();
        } catch (error) {
        }
        this.mediaRecorder = null;

        if (showMessage) {
            try {
                Video.showNotification('<i class="fas fa-play-circle"></i>', `You stopped streaming this Kino`)
            } catch (error) {
            }
        }

        localStorage.removeItem('streaming_status')
        $('#streaming-menu').removeClass('visible')
        clearInterval(this.streamLogInterval)

        await axios.get('/services/stream/cancel-resume').then(res => {

        }).catch(err => {
        })

        if (showMessage) {
            this.broadcastMessage("stopped_streaming")
        }
        this.streamingList = this.streamingList.filter(pp => pp != room.myUserId())
        this.liveStreamCountsEvent()

    }

    broadcastMessage(message) {
        room.broadcastEndpointMessage({
            message: message,
            sender: {
                id: room.myUserId(),
                name: MY_NAME
            }
        })
    }

    endpointMessageReceived(user, message) {
        if(message.type) return

        if(message.message) {
            if(message.message == "started_streaming") {
                try {
                    Video.showNotification('<i class="fas fa-play-circle"></i>', `${user._displayName} started streaming this Kino`)
                    $(`#${message.sender.id} .streaming-indicator`).addClass('streaming-on')
                    this.streamingList.push(message.sender.id)
                    this.liveStreamCountsEvent()
                } catch (error) {
                }
            } else if (message.message == "paused_streaming") {
                try {
                    Video.showNotification('<i class="fas fa-pause-circle"></i>', `${user._displayName} paused streaming this Kino`)
                    $(`#${message.sender.id} .streaming-indicator`).removeClass('streaming-on')
                    this.streamingList = this.streamingList.filter(pp => pp != message.sender.id)
                    this.liveStreamCountsEvent()
                } catch (error) {
                }
            } else if (message.message == "resumed_streaming") {



                try {
                    Video.showNotification('<i class="fas fa-play-circle"></i>', `${user._displayName} resumed streaming this Kino`)
                    $(`#${message.sender.id} .streaming-indicator`).addClass('streaming-on')
                    this.streamingList.push(message.sender.id)
                    this.liveStreamCountsEvent()
                } catch (error) {
                }
            } else if (message.message == "stopped_streaming") {
                try {
                    Video.showNotification('<i class="fas fa-stop-circle"></i>', `${user._displayName} stopped streaming this Kino`)
                    $(`#${message.sender.id} .streaming-indicator`).removeClass('streaming-on')
                    this.streamingList = this.streamingList.filter(pp => pp != message.sender.id)
                    this.liveStreamCountsEvent()
                } catch (error) {
                }
            }
        }
    }

    socketEvents(socket) {

        socket.on('connect_timeout', (timeout) => {
            console.error('_socket_timeout', m)
            this.video_stream.stop()
        });
        socket.on('error', (error) => {
            console.error('_socket_error', m)
            this.video_stream.stop()
        });

        socket.on('connect_error', (err) => {
            console.error('_socket_connect_error', m)
            this.video_stream.stop()
        });

        socket.on('message',(m) => {
            console.error('_socket_message', m)
        });

        socket.on('fatal', (m) => {
            console.error('_socket_fatal', m)
            //alert('Error:'+m);
            //already stopped and inactive
            this.video_stream.stop()
        });
    }

    //back buttons
    backFromPreviewStream(){
        this.previewStreamModal.modal('hide')
        if(this.stream) {
            this.stream
        }
        if(this.pendingStreamStatus) {
            this.pendingStreamModal.modal()
        } else {
            this.servicesModal.modal()
        }
    }

    backFromAddChannel(){
        this.channelSelectionModal.modal('hide')
        this.servicesModal.modal()
    }

    backFromSingleService(){
        this.singleServiceAuthModal.modal('hide')
        this.channelSelectionModal.modal()
    }

    showErrorMessage(message) {
        return `
            <div class="alert mb-0 custom-alert-primary mt-3" role="alert">
                <div class="row align-items-center">
                    <div class="col-auto font-md pr-0 black-color">
                        <i class="fas fa-exclamation-triangle h1" style="font-weight: 900"></i>
                    </div>
                    <div class="col black-color">
                        <p class='m-0'>${message}</p>
                    </div>
                </div>
            </div>
        `
    }

    // card 244
    showSuccessMessage(message) {
        return `
            <div class="alert mb-0 custom-alert-primary mt-3" role="alert">
                <div class="row align-items-center">
                    <div class="col-auto font-md pr-0 black-color">
                        <i class="fas fa-check-circle h1" style="font-weight: 900"></i>
                    </div>
                    <div class="col black-color">
                        <p class='m-0'>${message}</p>
                    </div>
                </div>
            </div>
        `
    }
    // end card 244

    hideErrorMessage() {
        $('#stream-channel-list .errors').empty();
    }

    // checkModalShow(e) {
    //     let id = e.currentTarget.id
    //     if(this.streamingStatus == "streaming" && id != 'live-modal-modal') {
    //         $(id).modal('hide')
    //     }
    // }

    showLiveStream(){
        if(this.disabled){
            return;
        }
        hideSideMenu()
        if(!this.showLastMinimizedModal()){
            return;
        }
        let streaming_stats = localStorage.getItem('streaming_status');
        if(streaming_stats) {
            streaming_stats = JSON.parse(streaming_stats)
            if(streaming_stats['lastUpdate'] && moment().diff(moment(streaming_stats['lastUpdate'])) > this.config.pauseTime) {
                this.cancelResumeStream()
                localStorage.removeItem('streaming_status');
            } else if(streaming_stats['kino_id'] && streaming_stats['kino_id'] != ROOM_NAME) {
                $('#modal-error-message').text('You have an active stream on another KINO.')
                $('#error-modal').modal()
                return
            } else if(streaming_stats['lastUpdate'] && moment().diff(moment(streaming_stats['lastUpdate'])) < this.config.pauseTime && moment().diff(moment(streaming_stats['last_pause_update'])) < 1000 ) {
                if($('#streaming-menu.visible').length) {
                    $('#streaming-menu').addClass('flash')
                    setTimeout(() => {
                        $('#streaming-menu').removeClass('flash')
                    }, 1200);
                } else {
                    $('#modal-error-message').text('You have an active stream on another window.')
                    $('#error-modal').modal()
                }
                return
            }
        }

        if(!this.streamingPermissions) {
            $('#modal-error-message').text('This is a premium feature.')
            $('#error-modal').modal()
            return false
        }

        if(!permissions.hasLiveStreaming()) {
            $('#modal-error-message').text('You do not have streaming permissions.')
            $('#error-modal').modal()
            return
        }
        if(this.streamingStatus == "streaming" || this.streamingStatus == "paused") {
            $('#streaming-menu').addClass('flash')
            setTimeout(() => {
                $('#streaming-menu').removeClass('flash')
            }, 1200);
        } else {
            this.servicesModal.modal()
        }
    }

    showLastMinimizedModal(){
        if( this.channelSelectionModal.hasClass('minimized-modal') ||
            this.singleServiceAuthModal.hasClass('minimized-modal') ||
            this.servicesModal.hasClass('minimized-modal') ||
            this.previewStreamModal.hasClass('minimized-modal') ||
            this.facebookSelectionModal.hasClass('minimized-modal') ||
            this.streamTitleModal.hasClass('minimized-modal') ||
            this.pendingStreamModal.hasClass('minimized-modal') ||
            this.resumeModal.hasClass('minimized-modal')){

            if(this.channelSelectionModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('channel-list-selection-modal');
            }
            if(this.singleServiceAuthModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('single-service-auth-modal');
            }
            if(this.servicesModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('live-stream-modal');
            }
            if(this.facebookSelectionModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('facebook-service-selection-modal');
            }
            if(this.previewStreamModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('preview-stream-modal');
            }
            if(this.streamTitleModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('stream-title-modal');
            }
            if(this.pendingStreamModal.hasClass('minimized-modal')){
                Video.minimizedContent.maximizeModal('pending-stream-modal');
            }

            return false;
        }else{
            return true;
        }
    }

    disableRecorder(){
        localRecording.disabled=true;
        if(localRecording.recorderControls){
            localRecording.recorderControls.remove();
            localRecording.recorderControls = null;
        }
        if($("#kinoRecordingBtn")){
            $("#kinoRecordingBtn").attr({
                "data-toggle": "tooltip",
                "data-placement": "top",
                "title":"Recording is disabled while a live streaming is active",
                "data-original-title": "Recording is disabled while a live streaming is active"
            }).addClass("button-disabled");
        }
    };

    enableRecorder(){
        localRecording.disabled=false;
        if($("#kinoRecordingBtn")){
            $("#kinoRecordingBtn").removeAttr(
                "data-toggle data-placement data-original-title title"
            ).removeClass("button-disabled");
        }
    };

}
